import React from 'react';

import { ItemTaskType } from '../../types';
import DrawerPanelListTaskEmpty from './drawerPanelListTaskEmpty';
import DrawerPanelTask from './drawerPanelTask';

interface IDrawerPanelListTaskForScheduleItem {
    listTaskForShow: ItemTaskType[];
}

const DrawerPanelListTaskForScheduleItem: React.FC<IDrawerPanelListTaskForScheduleItem> = ({ listTaskForShow }) => {
    return (
        <>
            {listTaskForShow.length ? (
                listTaskForShow.map((task) => {
                    return <DrawerPanelTask key={task.id} task={task} />;
                })
            ) : (
                <DrawerPanelListTaskEmpty />
            )}
        </>
    );
};

export default DrawerPanelListTaskForScheduleItem;
